import { type FC, useCallback, useState } from "react";

import { cx } from "@emotion/css";
import { Popover, PopoverPlacementTypes } from "@snapchat/snap-design-system";
import { FilterFilledIcon } from "@snapchat/snap-design-system-icons";

import { Flexbox } from "../../../../shared/components";
import { popoverStyle } from "../../../../shared/styles";
import { useLensFilterByStatus } from "../../../hooks";

import { statusWidth } from "./HeaderWidth.styles";
import { LensFilterOptions } from "./LensFilterOptions";
import { ClickableHeaderItem, filterIcon, filterIconActive } from "./LensesListHeader.styles";

export const LensStatusHeader: FC = () => {
    const [visible, setIsVisible] = useState(false);
    const { onFilterChange, selectedAll } = useLensFilterByStatus();

    const onVisibleChange = useCallback(
        (value: boolean) => {
            if (!value) {
                onFilterChange();
            }
            setIsVisible(value);
        },
        [onFilterChange],
    );

    return (
        <Popover
            trigger="click"
            placement={PopoverPlacementTypes.BOTTOM_LEFT}
            className={popoverStyle}
            visible={visible}
            onVisibleChange={onVisibleChange}
            content={
                <LensFilterOptions
                    onApplyFilters={() => {
                        onVisibleChange(false);
                    }}
                />
            }
        >
            <ClickableHeaderItem className={statusWidth} data-testid="filter-status-trigger">
                <Flexbox flexDirection="row" alignItems="center">
                    <span>Status</span>
                    <div className={cx(filterIcon, !selectedAll && filterIconActive)}>
                        <FilterFilledIcon size={16} />
                    </div>
                </Flexbox>
            </ClickableHeaderItem>
        </Popover>
    );
};
